import { render, staticRenderFns } from "./SupplierSummaryAccountStatement.vue?vue&type=template&id=3aa3c9d3&scoped=true&"
import script from "./SupplierSummaryAccountStatement.vue?vue&type=script&lang=js&"
export * from "./SupplierSummaryAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3c9d3",
  null
  
)

export default component.exports